import React from "react";

// Single shared candidate-row component for the Employer Dashboard (Próximas
// Entrevistas, Mejores Candidatos, Últimas Postulaciones). All three widgets
// render the SAME geometry — [Foto] Nombre / línea 1 (contexto) / línea 2
// (contexto o estado) / fila de acciones — and only pass different data via
// props. The three candidate-facing actions (Perfil · Mensaje · 3ra acción)
// always share the same institutional pink (#F55FA5), same size/weight,
// plain text (no pills/fills), so none reads as more important than another.
const PINK = "#F55FA5";
const ACTION_CLASS = "text-xs font-medium whitespace-nowrap leading-none transition-opacity hover:opacity-70 active:opacity-50";

export function CandidateActionButton({ onClick, testId, label }) {
  return (
    <button type="button" onClick={onClick} data-testid={testId} className={ACTION_CLASS} style={{ color: PINK }}>
      {label}
    </button>
  );
}

// Looks identical to the other two plain-text actions (always reads its
// `label`, e.g. "Cambiar etapa") while a real native <select> sits invisibly
// on top, so tapping it opens the native picker and still fires `onChange` —
// no separate popover/menu component needed to keep the change-stage flow working.
export function CandidateStageAction({ testId, ariaLabel, label, value, onChange, disabled, children }) {
  return (
    <span className="relative inline-flex items-center">
      <span className={ACTION_CLASS} style={{ color: PINK }}>{label}</span>
      <select
        data-testid={testId}
        aria-label={ariaLabel}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
      >
        {children}
      </select>
    </span>
  );
}

// line1/line2 typography is owned HERE (not by callers) — this is what keeps
// the 3 Employer Dashboard candidate lists (Próximas Entrevistas, Mejores
// Candidatos, Últimas Postulaciones) looking like one real component instead
// of 3 similar-but-different ones. Callers only pass plain text/inline color,
// never their own font-size or font-weight.
export function CandidateSummaryCard({ cardTestId, avatarUrl, name, line1, line2, profileAction, messageAction, thirdAction }) {
  return (
    <div data-testid={cardTestId} className="flex items-start gap-3 p-3 bg-slate-50 rounded-xl border border-slate-100">
      <div className="h-9 w-9 rounded-xl bg-[#028CF8]/10 flex items-center justify-center font-poppins font-bold text-[#028CF8] text-sm flex-shrink-0 overflow-hidden mt-0.5">
        {avatarUrl ? <img src={avatarUrl} alt={name} className="h-full w-full object-cover" /> : name?.[0]?.toUpperCase()}
      </div>
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-slate-900 text-sm truncate leading-tight">{name}</p>
        <div className="min-h-[32px] flex flex-col gap-0.5 mt-0.5 justify-center">
          {line1 && <div className="text-xs font-medium text-slate-500 truncate leading-snug">{line1}</div>}
          {line2 && <div className="text-xs font-medium leading-snug flex items-center gap-1.5 flex-wrap">{line2}</div>}
        </div>
        <div className="flex items-center flex-nowrap gap-x-4 mt-2">
          {profileAction && <CandidateActionButton {...profileAction} />}
          {messageAction && <CandidateActionButton {...messageAction} />}
          {thirdAction}
        </div>
      </div>
    </div>
  );
}
